export default __webpack_public_path__ + "54d6af007065a74dd41a685f9eaa2313.png";